<template>
    <div id="cduHeaderOuter">
        <div class="line-selector-container">  
            <line-selector v-for="item in 6" 
            :key="'l'+item" 
            @click.native="linePress('l'+item)"
            :class="{'btnAct': 'l'+item==currentKey}"/>
        </div>
        
        <div class="screen-container">
            <div class="white-line-container white-line-container-l">
                <div v-for="whiteLine in 6"></div>
            </div>

            <router-view ref="currentScreen"></router-view>

            <div class="white-line-container white-line-container-r">
                <div v-for="whiteLine in 6"></div>
            </div>
        </div>

        <div class="line-selector-container">
            <line-selector v-for="item in 6" 
            :key="'r'+item"
            @click.native="linePress('r'+item)"
            :class="{'btnAct': 'r'+item==currentKey}"/>
        </div>
    </div>
</template>

<script>

import LineSelector from 'views/cdu/cduHeader/LineSelector'
// import Screen from 'views/cdu/cduHeader/Screen'

import lineAction from 'utils/lineAction'

export default { 
    name: 'CduHeaderOuter',
    components: {
        LineSelector,
        // Screen
    },
    data() {
        return {
            currentKey: null
        }
    },
    methods: {
        linePress(lineKey){

            this.$emit('linePress',lineKey)
            this.currentKey = lineKey
            setTimeout(()=>{
                this.currentKey = null
            }, 100)

            lineAction(lineKey, this)
    } 
},

}
</script>

<style scoped>
    #cduHeaderOuter{
        position: absolute;
        width: 9.386667rem;
        height: 6.906667rem;
        margin: .12rem .12rem 0;
        border-radius: .16rem;
        border-top: #979898;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .line-selector-container{
        height: 4.16rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .screen-container{
        width: 7.706667rem;
        height: 6.306667rem;
        background: radial-gradient(#949292, #252527);
        border-radius: .2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .white-line-container{
        height: 3.8rem;
        width: .4rem;
        display: flex;
        flex-flow: column wrap;
        justify-content: space-between;
    }

    .white-line-container>div::before{
        content: "";
        display: block;
        width: .333333rem;
        height: .08rem;
        background-color: #fff;
    }

    .white-line-container-r{
        align-items: flex-end;
    }
</style>